var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import debounce from "@frameworks/web/utils/debounce";
import { TransactionTypeCodeEnum, TransactionTypeEnum, } from "@domains/features/Markets/AIF-PMS/entities/GlobalEntity";
import actions from "@mainDi/features/AIF-PMS/actions";
var purchaseController = function () {
    var cActions = actions();
    var _a = __read(useState(false), 2), errorVisible = _a[0], setErrorVisible = _a[1];
    var _b = __read(useState(""), 2), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var _d = __read(useState(true), 2), openVerifyClient = _d[0], setOpenVerifyClient = _d[1];
    var _e = useSelector(function (state) { return state.markets.AifPms; }), watchListData = _e.watchListData, transactionId = _e.transactionId, subCategoryId = _e.subCategoryId, clientDetails = _e.clientDetails, draftOrderDetails = _e.draftOrderDetails;
    var selectLeadId = useSelector(function (state) { return state.markets.global; }).selectLeadId;
    var selectLoginSearchData = useSelector(function (state) { return state.markets.leadservice; }).selectLoginSearchData;
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    var paymentProcess = useSelector(function (state) { return state.markets.payment; });
    var _f = useSelector(function (state) { return state.markets.payment; }), redeem = _f.redeem, purchase = _f.purchase, purchaseFee = _f.purchaseFee, topup = _f.topup, paymentMode = _f.paymentMode, paymentSuccess = _f.paymentSuccess, arnTransfer = _f.arnTransfer, uploadDeclaration = _f.uploadDeclaration;
    var searchParams = new URLSearchParams(location.search);
    var orders = useSelector(function (state) { return state.markets.purchase; }).orders;
    var validateForm = useSelector(function (state) { return state.markets.purchase; }).validateForm;
    var activeTypeList = useSelector(function (state) { return state.markets.global; }).activeTypeList;
    var isPurchaseDocs = (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) == TransactionTypeEnum.Redeem ||
        (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) == TransactionTypeEnum.TransferIn;
    var onSaveDraftOrders = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (paymentSuccess) {
            return;
        }
        aifPmsDi.draft
            .saveDraftOrders({
            schId: watchListData === null || watchListData === void 0 ? void 0 : watchListData.schemeId,
            categoryCode: subCategoryId,
            trxTypeCode: (_a = activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code) !== null && _a !== void 0 ? _a : 1,
            trxType: activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type,
            uccCode: (_b = clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.uniqueCode) !== null && _b !== void 0 ? _b : "",
            schCode: watchListData === null || watchListData === void 0 ? void 0 : watchListData.schemeId,
            orderPlacedBy: profileData.empcodetxt,
            trxAmt: Number(((_c = purchase.amount) === null || _c === void 0 ? void 0 : _c.split(",").join("")) ||
                ((_d = redeem.redeemAmount) === null || _d === void 0 ? void 0 : _d.split(",").join("")) ||
                ((_e = topup.amount) === null || _e === void 0 ? void 0 : _e.split(",").join("")) ||
                ((_f = arnTransfer.amount) === null || _f === void 0 ? void 0 : _f.split(",").join(""))),
            formNumber: purchase.formNo,
            trxId: transactionId,
            acCode: (_g = clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.accountCode) !== null && _g !== void 0 ? _g : "",
            paymentMode: paymentMode.bankName.value
                ? paymentProcess.paymentMode.type
                : "",
            bankName: paymentMode.bankName.label,
            bankCode: paymentMode.bankName.value,
            chequeNumber: paymentMode.type === "Cheque"
                ? Number(paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeNo) !== 0 || (paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeNo)
                    ? Number(paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeNo)
                    : null
                : null,
            chequeDate: paymentMode.type === "Cheque" && paymentMode.chequeDate
                ? moment(paymentMode.chequeDate).format("YYYY-MM-DD")
                : null,
            rtgsNumber: paymentMode.type === "RTGS" ? paymentMode.rtgsNo : "",
            setupFeePercent: Number(purchaseFee.setUpFees),
            passoutUserType: (_h = purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.sbName) === null || _h === void 0 ? void 0 : _h.display_type,
            passoutUserCode: (_j = purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.sbName) === null || _j === void 0 ? void 0 : _j.display_code,
            passoutPercent: Number(purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout),
            trempcode: (selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_code)
                ? selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_code
                : ((_k = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _k === void 0 ? void 0 : _k.trempcode)
                    ? (_l = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _l === void 0 ? void 0 : _l.trempcode
                    : null,
            trempname: (selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_name)
                ? selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_name
                : ((_m = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _m === void 0 ? void 0 : _m.trempname)
                    ? (_o = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _o === void 0 ? void 0 : _o.trempname
                    : null,
            leadId: ((_p = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _p === void 0 ? void 0 : _p.lead_id)
                ? String((_q = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _q === void 0 ? void 0 : _q.lead_id)
                : selectLeadId || "",
            folioNumber: (_r = (redeem.folio || (topup === null || topup === void 0 ? void 0 : topup.folio) || arnTransfer.transferIn)) !== null && _r !== void 0 ? _r : "",
        })
            .then(function (response) {
            var _a, _b, _c;
            if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.status) == "SUCCESS" ||
                ((_b = response.data) === null || _b === void 0 ? void 0 : _b.status) == "FAILUREDRAFT") {
                aifPmsDi.aifPms.updateTransactionId((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.trxId);
            }
            setErrorVisible(false);
            setErrorMessage("");
        })
            .catch(function (resp) {
            var _a;
            var resErrors;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.getErrorsObject()) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var error = resp === null || resp === void 0 ? void 0 : resp.getErrorData();
                setErrorVisible((error === null || error === void 0 ? void 0 : error.status) == "FAILURE");
                setErrorMessage(error === null || error === void 0 ? void 0 : error.message);
                resErrors = resp.getErrorData();
                aifPmsDi.aifPms.updateTransactionId(resErrors === null || resErrors === void 0 ? void 0 : resErrors.trxId);
                cActions.draft.saveDraftOrders({
                    requestid: "",
                    success: false,
                    message: "",
                    statuscode: resp.getErrorCode(),
                    errors: "",
                    data: resErrors,
                });
            }
        });
    };
    var uploadMultidocs = function (trx_id) {
        setLoading(true);
        var files = uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration.map(function (item) {
            var _a, _b, _c, _d, _e;
            return {
                category_code: subCategoryId,
                trx_id: Number(trx_id),
                file_data: (_b = (_a = item === null || item === void 0 ? void 0 : item.imageUrl) === null || _a === void 0 ? void 0 : _a.split(",")[1]) !== null && _b !== void 0 ? _b : "",
                filename: (_c = item.file.name) !== null && _c !== void 0 ? _c : "",
                fileType: (_e = (_d = item.imageUrl) === null || _d === void 0 ? void 0 : _d.split(",")[0]) !== null && _e !== void 0 ? _e : "",
            };
        });
        aifPmsDi.purchase
            .multidocs(files)
            .then(function (data) {
            setLoading(false);
        })
            .catch(function (error) {
            setLoading(false);
        });
    };
    var onClickContinue = function () {
        setLoading(true);
        debounce(function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
            aifPmsDi.purchase
                .orders({
                draft_trx_id: transactionId,
                category_code: subCategoryId,
                trx_type_code: (_a = activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code) !== null && _a !== void 0 ? _a : 1,
                trx_type: activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type,
                ucccode: (_b = clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.uniqueCode) !== null && _b !== void 0 ? _b : "",
                scheme_id: watchListData === null || watchListData === void 0 ? void 0 : watchListData.schemeId,
                trx_amt: Number(((_c = purchase.amount) === null || _c === void 0 ? void 0 : _c.split(",").join("")) ||
                    ((_d = topup.amount) === null || _d === void 0 ? void 0 : _d.split(",").join("")) ||
                    ((_e = redeem.redeemAmount) === null || _e === void 0 ? void 0 : _e.split(",").join("")) ||
                    ((_f = arnTransfer.amount) === null || _f === void 0 ? void 0 : _f.split(",").join(""))),
                ac_code: (_g = clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.accountCode) !== null && _g !== void 0 ? _g : "",
                form_number: purchase.formNo,
                payment_mode: isPurchaseDocs ? "" : paymentMode.type,
                bank_name: paymentMode.bankName.label,
                bank_code: paymentMode.bankName.value,
                cheque_number: paymentMode.type === "Cheque" ? Number(paymentMode.chequeNo) : null,
                trx_status_code: 0,
                cheque_date: paymentMode.type === "Cheque" && paymentMode.chequeDate
                    ? moment(paymentMode.chequeDate).format("YYYY-MM-DD")
                    : null,
                rtgs_number: paymentMode.type === "RTGS" ? paymentMode.rtgsNo : "",
                setup_fee_percent: Number(purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.setUpFees),
                passout_user_type: ((_j = (_h = purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.sbName) === null || _h === void 0 ? void 0 : _h.display_type) === null || _j === void 0 ? void 0 : _j.trim()) == ""
                    ? null
                    : (_k = purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.sbName) === null || _k === void 0 ? void 0 : _k.display_type,
                passout_user_code: ((_m = (_l = purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.sbName) === null || _l === void 0 ? void 0 : _l.display_code) === null || _m === void 0 ? void 0 : _m.trim()) == ""
                    ? null
                    : (_o = purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.sbName) === null || _o === void 0 ? void 0 : _o.display_code,
                folio_number: (_p = (topup.folio || (redeem === null || redeem === void 0 ? void 0 : redeem.folio) || arnTransfer.transferIn)) !== null && _p !== void 0 ? _p : "",
                redeem_reason: (_q = redeem === null || redeem === void 0 ? void 0 : redeem.reason) !== null && _q !== void 0 ? _q : "",
                lead_id: ((_r = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _r === void 0 ? void 0 : _r.lead_id)
                    ? String((_s = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _s === void 0 ? void 0 : _s.lead_id)
                    : selectLeadId || "",
                passout_percent: (purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout) == "" ? null : Number(purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout),
                trx_qty: (_t = redeem.approxUnit) !== null && _t !== void 0 ? _t : 0,
                trempcode: (selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_code)
                    ? selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_code
                    : ((_u = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _u === void 0 ? void 0 : _u.trempcode)
                        ? (_v = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _v === void 0 ? void 0 : _v.trempcode
                        : null,
                trempname: (selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_name)
                    ? selectLoginSearchData === null || selectLoginSearchData === void 0 ? void 0 : selectLoginSearchData.display_name
                    : ((_w = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _w === void 0 ? void 0 : _w.trempname)
                        ? (_x = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _x === void 0 ? void 0 : _x.trempname
                        : null,
            })
                .then(function (response) {
                var _a;
                setLoading(false);
                if (response.statuscode == String(400)) {
                }
                else {
                    if (isPurchaseDocs) {
                        uploadMultidocs((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.trx_id);
                    }
                    aifPmsDi.aifPms.ordersData(response === null || response === void 0 ? void 0 : response.data);
                    aifPmsDi.payment.updatePurchaseSuccess(true);
                    aifPmsDi.global.activeTrxTypeList(activeTypeList);
                }
            })
                .catch(function (error) {
                setLoading(false);
            });
        }, 2000)();
    };
    var clearPurchaseValues = function () {
        var uccCode = searchParams.get("ucc");
        aifPmsDi.global.activeTrxTypeList({
            trx_type: TransactionTypeEnum.Purchase,
            trx_type_code: TransactionTypeCodeEnum.Purchase,
        });
        aifPmsDi.payment.updatePurchaseSuccess(false);
        aifPmsDi.payment.resetValue();
        aifPmsDi.aifPms.updateTransactionId(0);
        if (!uccCode) {
            aifPmsDi.aifPms.updateClientDetails(null);
        }
        aifPmsDi.purchase.updateOrders(null);
        aifPmsDi.draft.updateDraftOrders(null);
        // if (typeof searchParams !== "undefined") {
        //   const url = window.location.pathname;
        //   window.history.replaceState(null, "", url);
        // }
    };
    useEffect(function () {
        var _a;
        var validJourney = (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) == TransactionTypeEnum.Purchase ||
            (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) == TransactionTypeEnum.TopUp;
        var isValid = ((purchase === null || purchase === void 0 ? void 0 : purchase.formNo) && (purchase === null || purchase === void 0 ? void 0 : purchase.amount) && (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.uniqueCode)) ||
            (topup.amount && topup.folio) ||
            (redeem.folio && redeem.redeemAmount) ||
            (arnTransfer.transferIn && arnTransfer.amount);
        var formNumberValidated = validateForm && validateForm.data && validateForm.data.is_formNoExist;
        if (paymentSuccess == false &&
            isValid &&
            validJourney &&
            !formNumberValidated) {
            if (((_a = orders === null || orders === void 0 ? void 0 : orders.data) === null || _a === void 0 ? void 0 : _a.status) == "SUCCESS") {
            }
            else {
                debounce(function () {
                    onSaveDraftOrders();
                }, 3000)();
            }
        }
    }, [
        paymentProcess.arnTransfer,
        paymentProcess.paymentMode,
        paymentProcess.paymentSuccess,
        paymentProcess.purchase,
        paymentProcess.purchaseFee,
        paymentProcess.redeem,
        paymentProcess.topup,
        paymentProcess.watchListData,
    ]);
    return {
        loading: loading,
        onClickContinue: onClickContinue,
        setOpenVerifyClient: setOpenVerifyClient,
        openVerifyClient: openVerifyClient,
        clearPurchaseValues: clearPurchaseValues,
        errorMessage: errorMessage,
        errorVisible: errorVisible,
        setLoading: setLoading,
    };
};
export default purchaseController;
